export default __webpack_public_path__ + "static/media/solar_oli.50490ad8.svg";